module.exports = {"632801001":"昆仑路街道","632801002":"黄河路街道","632801003":"金峰路街道","632801004":"河西街道","632801005":"西藏路街道","632801100":"郭勒木德镇","632801101":"唐古拉镇","632801200":"大格勒乡","632801201":"乌图美仁乡","632801400":"察尔汗工行委","632801401":"格尔木农垦有限公司"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632801.json
// module id = 3017
// module chunks = 0